export enum OperandTypeEnum {
    And = 1,
    Or = 2
}
